import {
  StyledPaper,
  StyledBox,
  VisitText,
  PointsPerVisit,
  BalanceBox,
  Tick,
  StyledLogo,
} from './VisitCard.styles';

export interface VisitCardProps {
  visits: string;
  suffix: string;
  points: number;
  isCompleted: boolean;
  tier: number;
}

function VisitCard({ visits, suffix, points, isCompleted, tier }: VisitCardProps) {
  return (
    <StyledPaper>
      <StyledBox complete={`${isCompleted}`}>
        <Tick complete={`${isCompleted}`} tier={tier} />
        <VisitText variant="h2">
          {visits}
          <sup>{suffix}</sup>
        </VisitText>
        <VisitText variant="h2">VISIT</VisitText>
      </StyledBox>

      <BalanceBox complete={`${isCompleted}`}>
        <PointsPerVisit variant="h2">+{points}</PointsPerVisit>
        <StyledLogo />
      </BalanceBox>
    </StyledPaper>
  );
}

export default VisitCard;
